import Modal from 'components/Shared/Modal';
import { Button } from 'components/Button';
import { ReactNode } from 'react';
import styles from './styles.scss';
import { getVideoTitle, getVideoId } from './selectors';
import { closeVideo } from './actions';
import { useDispatch, useSelector } from 'react-redux';
import { NO_ELEMENT, rm } from 'utils';
import { getEmbedUrl } from 'components/Shared/Image';

interface VideoPlayerContainerProps {
  children?: ReactNode;
}

const VideoPlayerContainer = ({ children }: VideoPlayerContainerProps) => {
  return <div className={styles.videoPlayerContainer}>{children}</div>;
};

interface ProductVideoProps {
  videoId?: string;
}

const ProductVideo = ({ videoId }: ProductVideoProps) => {
  if (!videoId) {
    return NO_ELEMENT;
  }
  return (
    <VideoPlayerContainer>
      <iframe
        allowFullScreen
        className={styles.videoFrame}
        frameBorder="none"
        src={getEmbedUrl(videoId)}
      />
    </VideoPlayerContainer>
  );
};

export const VideoPlayer = () => {
  const dispatch = useDispatch();
  const close = () => dispatch(closeVideo());
  const id = useSelector(getVideoId);
  const title = useSelector(getVideoTitle);

  return (
    <Modal
      show={!!id}
      onClose={close}
      overlayClassName={styles.modal}
      contentClassName={styles.content}
    >
      <h2>{title}</h2>
      <ProductVideo videoId={id} />
      <Button
        onClick={close}
        textTransform="uppercase"
        className={styles.addToCartButton}
        appearance="quaternary"
      >
        {rm('red_drawer_default_close_text')}
      </Button>
    </Modal>
  );
};
